import { ApiAuthentication } from "enum/api";
import { FnAxios, FnDialog, I18n, SecureStorage } from "./utilities";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router";
import { I18NextNs } from "enum/enum";
import DialogActionCreators from "store/redux/DialogAlert";
import { useDispatch } from "react-redux";

export const GetMenuPermission = async (AxiosFn, FnState, DialogFn) => {
	let sRoute = window.location.pathname.toLocaleLowerCase().toString();
	await AxiosFn.Get(ApiAuthentication.GetPermission, { sRoute: sRoute }, (result) => {
		let objData = result.objResult;
		FnState(objData.nPermission === 2);
		if (objData.nPermission === 0) NoPermission(DialogFn);
	});
};

export const GetMenuPermissionRetunVal = async (AxiosFn) => {
	let sRoute = window.location.pathname.toLocaleLowerCase().toString();
	await AxiosFn.Get(ApiAuthentication.GetPermission, { sRoute: sRoute }, (result) => {
		let objData = result.objResult;
		return objData.nPermission === 2;
	});
};

export const GetUserAccout = () => {
	let sJwt = SecureStorage.Get(process.env.REACT_APP_JWT_KEY);
	let user: IAvatar = {};
	if (sJwt) {
		user = jwt_decode(sJwt);
	}
	return user;
};

export const DefaultArrayEmpty = (arrData) => {
	return arrData ?? [];
};

export const NoPermission = (DialogFn) => {
	if (DialogFn) {
		DialogFn.Warning(I18n.SetText(`Message.NoPermission`, I18NextNs.labelComponent), () => {
			window.location.href = (process.env.REACT_APP_URL + "Home");
		});
	}
};

export const GetMenuPermissionParamRoute = async (pathname, AxiosFn, FnState, DialogFn) => {
	let sRoute = pathname.toLocaleLowerCase().toString();
	await AxiosFn.Get(ApiAuthentication.GetPermission, { sRoute: sRoute }, (result) => {
		let objData = result.objResult;
		FnState(objData.nPermission === 2);
		if (objData.nPermission === 0) NoPermission(DialogFn);
	});
};